export default __webpack_public_path__ + "static/media/ic_attach_money_blue_48px.4812515b.svg";